<script>
	import { yesNoToBoolean } from "src/utils/misc";
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import CustomDatePicker from "src/components/CustomDatePicker/CustomDatePicker.svelte";
	import CustomSelect from "src/components/CustomSelect/CustomSelect.svelte";
	import LimitSize from "src/components/SizeSelect/limitSize.svelte";
	import { workOrderStatusOptions, flaggedOptions } from "src/utils/options";

	export let changeSearchParams = () => {};
	export let params = {};

	const pageSizeOptions = [
		{ value: "10", label: "Show 10" },
		{ value: "20", label: "Show 20" },
		{ value: "50", label: "Show 50" },
	];

	const statusSelectOptions = workOrderStatusOptions;

	function booleanToYesNo(value) {
		return value === true ? "Yes" : value === false ? "No" : "";
	}

	let flaggedFilter = booleanToYesNo(params.flagged);
	let statusFilter = params.status || "";

	let formValues = {
		code: params.code || "",
		addedByEmail: params.addedByEmail || "",
	};

	let lastUpdatedRange =
		params.lastUpdatedFrom && params.lastUpdatedTo
			? [params.lastUpdatedFrom, params.lastUpdatedTo]
			: [];

	let dateCreatedRange =
		params.dateCreatedFrom && params.dateCreatedTo
			? [params.dateCreatedFrom, params.dateCreatedTo]
			: [];

	function handleSubmit() {
		changeSearchParams({
			...formValues,
			flagged: yesNoToBoolean(flaggedFilter),
			status: statusFilter,
			lastUpdatedFrom: lastUpdatedRange[0] || "",
			lastUpdatedTo: lastUpdatedRange[1] || "",
			dateCreatedFrom: dateCreatedRange[0] || "",
			dateCreatedTo: dateCreatedRange[1] || "",
		});
	}
</script>

<div class="d-flex justify-content-between align-items-start">
	<form on:submit|preventDefault={handleSubmit} style="max-width: 900px;">
		<Row className="mx-0">
			<Col xs={9}>
				<Row class="gx-2">
					<Col xs={4}>
						<input
							type="text"
							class="form-control getgo input search-icon my-1"
							name="code"
							placeholder="Search by ID"
							aria-label="Search by ID"
							bind:value={formValues.code}
						/>
					</Col>
					<Col xs={4}>
						<CustomDatePicker
							name="lastUpdatedAt"
							placeholder="Last updated"
							isRange={true}
							bind:value={lastUpdatedRange}
						/>
					</Col>
					<Col xs={4}>
						<CustomDatePicker
							name="createdAt"
							placeholder="Date created"
							isRange={true}
							bind:value={dateCreatedRange}
						/>
					</Col>
				</Row>

				<Row class="gx-2">
					<Col xs={4}>
						<CustomSelect
							id="wo-flagged"
							label="Filter by flagged status"
							defaultOption="Flagged"
							bind:value={flaggedFilter}
							options={flaggedOptions}
						/>
					</Col>
					<Col xs={4}>
						<CustomSelect
							id="wo-status"
							label="Filter by status"
							defaultOption="All statuses"
							bind:value={statusFilter}
							options={statusSelectOptions}
						/>
					</Col>
					<Col xs={4}>
						<input
							type="text"
							class="form-control getgo input search-icon my-1"
							name="addedByEmail"
							placeholder="Search by email"
							aria-label="Search by email"
							bind:value={formValues.addedByEmail}
						/>
					</Col>
				</Row>
			</Col>

			<Col
				xs={3}
				class="d-flex align-self-end my-1"
				style="padding-left: 0;"
			>
				<Button class="themeButton primary" type="submit">
					Search
				</Button>
			</Col>
		</Row>
	</form>

	<div class="ms-3 align-self-end work-order-page-size">
		<LimitSize options={pageSizeOptions} />
	</div>
</div>

<style>
	:global(.work-order-page-size #size) {
		width: 120px;
	}
</style>
